import { colors } from 'baseui/tokens';
import { string2money } from 'common/utils/string';
import DrawerHeader from 'components/common/drawer/drawer-header';
import { DrawerBody } from 'components/common/drawer/styles';
import Text from 'components/elements/text';
import { SeparatorHorizontal, SeparatorVertical } from 'components/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import SummaryItem from './summary-item';
import useRecalculate from '../../hooks/use-recalculate';
import { TotalContent, TotalItemContent } from '../../style';
import { TourSaleFormType } from '../form-type';

interface Props {
  onClose: () => void;
}

export default function SummaryDrawer(props: Props) {
  const { t } = useTranslation();
  const { onClose } = props;
  const { getValues } = useFormContext<TourSaleFormType>();
  const tourSales = getValues('tourSales');
  const { subtotal, discount, otherCost, total } = useRecalculate();

  return (
    <>
      <DrawerHeader onClose={onClose} title={t('common:tour_sales_detail')} />
      <DrawerBody>
        {tourSales.map((item, idx) => (
          <React.Fragment key={item.customId}>
            <SummaryItem parentIdx={idx} data={item} />
          </React.Fragment>
        ))}

        <SeparatorVertical $margin={24}>
          <div style={{ height: 1, backgroundColor: colors.gray200 }} />
        </SeparatorVertical>
        <TotalContent>
          <TotalItemContent>
            <Text variant="LabelMedium">{t('common:subtotal')}:</Text>
            <SeparatorHorizontal $margin={8} />
            <Text variant="HeadingXSmall">{`Rp ${string2money(
              subtotal,
            )}`}</Text>
          </TotalItemContent>
        </TotalContent>
        <TotalContent>
          <TotalItemContent>
            <Text variant="LabelMedium">{t('common:discount')}:</Text>
            <SeparatorHorizontal $margin={8} />
            <Text variant="HeadingXSmall">{`Rp ${string2money(
              discount,
            )}`}</Text>
          </TotalItemContent>
        </TotalContent>
        <TotalContent>
          <TotalItemContent>
            <Text variant="LabelMedium">{t('common:other_cost')}:</Text>
            <SeparatorHorizontal $margin={8} />
            <Text variant="HeadingXSmall">{`Rp ${string2money(
              otherCost,
            )}`}</Text>
          </TotalItemContent>
        </TotalContent>
        <TotalContent>
          <TotalItemContent>
            <Text variant="LabelMedium">{t('common:total')}:</Text>
            <SeparatorHorizontal $margin={8} />
            <Text variant="HeadingXSmall">{`Rp ${string2money(total)}`}</Text>
          </TotalItemContent>
        </TotalContent>
      </DrawerBody>
    </>
  );
}
